import styled from "styled-components";

export const StyledPaddingDiv = styled.div`
  padding: 0 2rem;

 
  }
`;
